<app-filter-header title="Filtrar" i18n-title (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-radio-group title="Matrículas" i18n-title [labels]="this.labelsMatriculas" [values]="this.matriculasValues" [(value)]="this.vellesONoves"></app-form-radio-group>
  </div>
</div>